module.exports = __webpack_public_path__ + "img/how_to_play.748d6f51.png";